import clsx from "clsx";
import React, {useEffect, useState} from "react";
import {playAudio} from "../../../../../_kiloit/helpers/Audio";

const CountDownTimer = ({time, className = ""}) => {

    const [count, setCountDown] = useState(0);


    useEffect(() => {
        let countDownInv: any;
        let countDown = time;
        if (countDown <= 0) return;
        setCountDown(countDown);
        countDownInv && clearInterval(countDownInv);
        countDownInv = setInterval(() => {
            countDown--;
            if (countDown <= 10) playAudio("/countdown.mp3");
            if (countDown === 0) playAudio("/goodluck.mp3");
            if (countDown <= 0) clearInterval(countDownInv);
            setCountDown(countDown < 0 ? 0 : countDown);
        }, 1000);
        return () => clearInterval(countDownInv);
    }, [time]);

    return <span id="timer-countdown"
                 className={clsx(`text-black display-1 fw-bold ${className}`, {
                     "text-danger": count <= 10
                 })}>{count < 0 ? 0 : count}</span>
}

export default CountDownTimer;